var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splashscreen"},[_c('div',{staticClass:"loading-spinner-wrapper"},[_c('div',{staticClass:"loading-spinner pb-3 pt-3"},[_c('span',{staticClass:"loading-spinner-content"},[_vm._v(" "+_vm._s(_vm.$t('ui.loadingDataInProgress'))+"… ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }